import React, { FC, Fragment } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { Sample } from 'models/order';

type SamplePackageProps = {
    sample: Sample;
};
const SampleSummary: FC<SamplePackageProps> = ({ sample }: SamplePackageProps) => {
    const { t: translate } = useTranslation();

    const showSampleContent = () => {
        if (sample && sample.content) {
            return sample.content.some((content) => content.value);
        } else {
            return false;
        }
    };

    return (
        <Fragment>
            <Box display="flex">
                <Box mr={1}>
                    <Typography variant="subtitle2">{translate('orders:SAMPLE_TAKEN')}:</Typography>
                </Box>
                <Box>{translate(`orders:${sample.type || ''}`)}</Box>
            </Box>

            {sample.type === 'PHYSICAL' && showSampleContent() ? (
                <Box display="flex">
                    <Box mr={1}>
                        <Typography variant="subtitle2">{translate('orders:CONTENT_IN_DELIVERY')}:</Typography>
                    </Box>
                    <Box>
                        {sample.content &&
                            sample.content
                                .filter((cont) => cont.value)
                                .map((content) => translate(`orders:${content.name}`))
                                .join(', ')}
                    </Box>
                </Box>
            ) : undefined}

            {sample.otherContent ? (
                <Box display="flex">
                    <Box mr={1}>
                        <Typography variant="subtitle2">{translate('orders:OTHER_CONTENT')}:</Typography>
                    </Box>
                    <Box>{sample.otherContent}</Box>
                </Box>
            ) : undefined}
        </Fragment>
    );
};

export default SampleSummary;
